'use client';

import { __awaiter, __generator, __assign } from '../_virtual/_tslib.js';
import React__default, { useState, useRef, useEffect } from 'react';
import UploadFile from './components/UploadFile.js';
import UserInfo from './components/UserInfo.js';
import { decrypt } from '../Utils/helpers.js';
import { colors, ELanguage } from '../Utils/constants.js';
import { EApplyType } from './type.js';
import { PopupQuickApplyJob, Container, Head, Body, CoverLetter, Textarea, ErrorMsg, AlignRight, Link, ApplyCV, ApplyCVTitle, Searchable, PrivacyPolicyContainer, CheckBoxGroup, CheckboxLabel, CheckboxLink, ErrorMessage, ButtonWrap } from './Styled.css.js';
import { getInfoWhenApplyOneClick, applyJobs, getJobLevelList, getPrivacyPolicy, getResumeSettingInfo } from './service.js';
import Radio from './components/Radio.js';
import SystemError from './components/SystemError.js';
import CompanyInfo from './components/CompanyInfo.js';
import { objToQueryStr } from '../Utils/urlBuilder.js';
import LoadingIcon from '../Images/LoadingIcon/index.js';
import { getProfileSettingCookie, setProfileSettingCookie } from './utils.js';
import { UserInfoSkeleton, JobInfoSkeletion } from './components/Skeletion.js';
import translations from './translations.js';
import { INTERN_LEVEL, FRESHER_LEVEL, MANAGER_LEVEL, DIRECTOR_LEVEL, ALLOW_SEARCHABLE } from './const.js';
import PopupWarning from '../PopupWarning/index.js';
import Button from '../Button/index.js';
import CheckBox from '../CheckBox/index.js';

function QuickApplyJobModal(_a) {
    var _this = this;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var isShow = _a.isShow, lang = _a.lang, handleClose = _a.handleClose, onForceClose = _a.onForceClose, accessToken = _a.accessToken, jobId = _a.jobId, jobInfo = _a.jobInfo, baseMsUrl = _a.baseMsUrl, baseUrl = _a.baseUrl, pageSource = _a.pageSource, utm = _a.utm, userInfo = _a.userInfo;
    var _l = useState(false), isShowApplyJob = _l[0], setIsShowApplyJob = _l[1];
    var _m = useState(false), isLoading = _m[0], setLoading = _m[1];
    var _o = useState(''), applyMessage = _o[0], setApplyMessage = _o[1];
    var _p = useState(), applyJobInfo = _p[0], setApplyJobInfo = _p[1];
    var _q = useState(EApplyType.lastAttachment), applyType = _q[0], setApplyType = _q[1];
    var _r = useState(null), applyJobParams = _r[0], setApplyJobParams = _r[1];
    var _s = useState(false), isSearchable = _s[0], setIsSearchable = _s[1];
    var _t = useState(true), isDisable = _t[0], setIsDisable = _t[1];
    var _u = useState(null), jobLevels = _u[0], setJobLevels = _u[1];
    var _v = useState({
        isJobtitleError: false,
        isPhoneError: false,
        isCoverLetterError: false
    }), applyError = _v[0], setApplyError = _v[1];
    var _w = useState(), resumeSettingInfo = _w[0], setResumeSettingInfo = _w[1];
    var _x = useState(false), isCheckedPrivacy = _x[0], setCheckedPrivacy = _x[1];
    var _y = useState([]), privacyPolicy = _y[0], setPrivacyPolicy = _y[1];
    var _z = useState(false), isPrivacyError = _z[0], setShowPrivacyError = _z[1];
    var uploadFileRef = useRef(null);
    var userInfoRef = useRef(null);
    var decryptToken = decrypt(accessToken !== null && accessToken !== void 0 ? accessToken : '');
    var t = function (text) {
        if (lang === 'vi') {
            return text;
        }
        else {
            return translations[text];
        }
    };
    var getProfileResumeSettingInfo = function () { return __awaiter(_this, void 0, void 0, function () {
        var resumeSettingInfo_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getResumeSettingInfo(decryptToken, lang, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '')];
                case 1:
                    resumeSettingInfo_1 = _a.sent();
                    if (resumeSettingInfo_1) {
                        setResumeSettingInfo(resumeSettingInfo_1);
                        return [2 /*return*/, resumeSettingInfo_1];
                    }
                    return [2 /*return*/, undefined];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [2 /*return*/, undefined];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var infoParamsApplyJob = function (type, response) {
        var _a, _b, _c, _d, _e, _f, _g;
        var resume = (_a = response === null || response === void 0 ? void 0 : response.resumes) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.type === type; });
        setIsDisable((resume === null || resume === void 0 ? void 0 : resume.allowSearchableDisplay) !== ALLOW_SEARCHABLE);
        setApplyJobParams(__assign(__assign({}, applyJobParams), { appJobTitle: (_c = (_b = response === null || response === void 0 ? void 0 : response.userInfo) === null || _b === void 0 ? void 0 : _b.jobtitle) !== null && _c !== void 0 ? _c : '', appPhoneNumber: (_e = (_d = response === null || response === void 0 ? void 0 : response.userInfo) === null || _d === void 0 ? void 0 : _d.cellphone) !== null && _e !== void 0 ? _e : '', resumeApply: (_f = resume === null || resume === void 0 ? void 0 : resume.value) !== null && _f !== void 0 ? _f : '', onlineResumeId: (_g = resume === null || resume === void 0 ? void 0 : resume.value) !== null && _g !== void 0 ? _g : '', resumeFile: resume === null || resume === void 0 ? void 0 : resume.resumeFile, appliedType: type, jobId: String(jobId !== null && jobId !== void 0 ? jobId : ''), source: pageSource !== null && pageSource !== void 0 ? pageSource : 'searchResults' }));
    };
    var getInfo = function () { return __awaiter(_this, void 0, void 0, function () {
        var resumeInfo_1, response, newResumes_1, newApplyJobInfo, applyTypes_1, userId, lastChooseCV, isOnlyLastAttachmentCVOrBoth, isOnlyOnlineProfile, applyType_1, error_2;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 3, , 4]);
                    return [4 /*yield*/, getProfileResumeSettingInfo()];
                case 1:
                    resumeInfo_1 = _f.sent();
                    return [4 /*yield*/, getInfoWhenApplyOneClick({
                            jobid: jobId,
                            baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '',
                            langCode: lang
                        })];
                case 2:
                    response = _f.sent();
                    if (response && response.status === 'SUCCESS') {
                        newResumes_1 = [];
                        if (resumeInfo_1) {
                            // merge allowSearchableDisplay to resume info
                            (_a = response === null || response === void 0 ? void 0 : response.resumes) === null || _a === void 0 ? void 0 : _a.forEach(function (resume) {
                                var _a, _b;
                                var itemAttr = (_a = resumeInfo_1.attributes) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.id === Number(resume.value); });
                                if (itemAttr && itemAttr.id === Number(resume.value)) {
                                    var itemNewResume = __assign(__assign({}, resume), { allowSearchableDisplay: (_b = itemAttr === null || itemAttr === void 0 ? void 0 : itemAttr.allowSearchableDisplay) !== null && _b !== void 0 ? _b : 0 });
                                    newResumes_1.push(itemNewResume);
                                }
                            });
                        }
                        newApplyJobInfo = __assign(__assign({}, response), { resumes: newResumes_1 });
                        setApplyJobInfo(newApplyJobInfo);
                        applyTypes_1 = [];
                        (_b = newApplyJobInfo.resumes) === null || _b === void 0 ? void 0 : _b.forEach(function (item) {
                            if (item.type) {
                                applyTypes_1.push(item.type);
                            }
                        });
                        userId = (_d = (_c = newApplyJobInfo === null || newApplyJobInfo === void 0 ? void 0 : newApplyJobInfo.userInfo) === null || _c === void 0 ? void 0 : _c.userid) !== null && _d !== void 0 ? _d : 0;
                        lastChooseCV = (_e = getProfileSettingCookie(String(userId))) === null || _e === void 0 ? void 0 : _e.chooseCV;
                        isOnlyLastAttachmentCVOrBoth = (!applyTypes_1.includes(EApplyType.online) && applyTypes_1.includes(EApplyType.lastAttachment)) ||
                            (applyTypes_1.includes(EApplyType.online) && applyTypes_1.includes(EApplyType.lastAttachment));
                        isOnlyOnlineProfile = applyTypes_1.includes(EApplyType.online) && !applyTypes_1.includes(EApplyType.lastAttachment);
                        if (lastChooseCV) {
                            applyType_1 = applyTypes_1.includes(EApplyType.online) && lastChooseCV === 'profile'
                                ? EApplyType.online
                                : EApplyType.lastAttachment;
                            setApplyType(applyType_1);
                            infoParamsApplyJob(applyType_1, newApplyJobInfo);
                        }
                        else if (isOnlyLastAttachmentCVOrBoth) {
                            setApplyType(EApplyType.lastAttachment);
                            infoParamsApplyJob(EApplyType.lastAttachment, newApplyJobInfo);
                        }
                        else if (isOnlyOnlineProfile) {
                            setApplyType(EApplyType.online);
                            infoParamsApplyJob(EApplyType.online, newApplyJobInfo);
                        }
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _f.sent();
                    console.error(error_2);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var onTextAreaChange = function (e) {
        var _a;
        setApplyError(__assign(__assign({}, applyError), { isCoverLetterError: false }));
        var target = e.target;
        target.style.height = "".concat(target.scrollHeight, "px");
        if (!target.value) {
            target.style.height = '44px';
        }
        setApplyJobParams(__assign(__assign({}, applyJobParams), { coverLetter: (_a = target.value) !== null && _a !== void 0 ? _a : '' }));
    };
    var handleChangeResume = function (type) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (!type)
            return;
        setApplyType(type);
        var resume = (_a = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.type === type; });
        setIsDisable((resume === null || resume === void 0 ? void 0 : resume.allowSearchableDisplay) !== ALLOW_SEARCHABLE);
        setApplyJobParams(__assign(__assign({}, applyJobParams), { appJobTitle: (_c = (_b = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo) === null || _b === void 0 ? void 0 : _b.jobtitle) !== null && _c !== void 0 ? _c : '', appPhoneNumber: (_e = (_d = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo) === null || _d === void 0 ? void 0 : _d.cellphone) !== null && _e !== void 0 ? _e : '', resumeApply: (_f = resume === null || resume === void 0 ? void 0 : resume.value) !== null && _f !== void 0 ? _f : '', onlineResumeId: (_g = resume === null || resume === void 0 ? void 0 : resume.value) !== null && _g !== void 0 ? _g : '', resumeFile: resume === null || resume === void 0 ? void 0 : resume.resumeFile, appliedType: type, jobId: String(jobId !== null && jobId !== void 0 ? jobId : ''), source: pageSource !== null && pageSource !== void 0 ? pageSource : 'searchResults' }));
    };
    var handleChangeInput = function (value, type) {
        setApplyJobInfo(__assign(__assign({}, applyJobInfo), { userInfo: __assign(__assign({}, applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo), (type === 'phone' ? { cellphone: value } : { jobtitle: value })) }));
        setApplyJobParams(__assign(__assign({}, applyJobParams), (type === 'phone' ? { appPhoneNumber: value } : { appJobTitle: value })));
    };
    useEffect(function () {
        if (jobId && isShow && accessToken) {
            getInfo();
        }
    }, [jobId, isShow, accessToken]);
    var onClickMakeSearchable = function (e) {
        var target = e.target;
        setIsSearchable(target.checked);
        setApplyJobParams(__assign(__assign(__assign({}, applyJobParams), { appSearchable: target.checked ? '1' : '0' }), (target.checked ? { 'make-searchable': 'on' } : undefined)));
    };
    useEffect(function () {
        var _a;
        if ((_a = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) === null || _a === void 0 ? void 0 : _a.find(function (e) { return e.type === EApplyType.newAttachment; })) {
            handleChangeResume(EApplyType.newAttachment);
        }
    }, [applyJobInfo]);
    var validate = function () {
        var _a, _b, _c;
        var isValid = true;
        var error = {
            isJobtitleError: false,
            isPhoneError: false,
            isCoverLetterError: false
        };
        if ((applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.requiredCoverLetter) &&
            (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.requiredCoverLetter) === 1 &&
            !(applyJobParams === null || applyJobParams === void 0 ? void 0 : applyJobParams.coverLetter)) {
            error.isCoverLetterError = true;
            isValid = false;
        }
        var isNotValidJobTitle = (_a = userInfoRef.current) === null || _a === void 0 ? void 0 : _a.validateJobTitle((_b = applyJobParams === null || applyJobParams === void 0 ? void 0 : applyJobParams.appJobTitle) !== null && _b !== void 0 ? _b : '');
        if (!(applyJobParams === null || applyJobParams === void 0 ? void 0 : applyJobParams.appJobTitle) || isNotValidJobTitle) {
            error.isJobtitleError = true;
            isValid = false;
        }
        var isNotValidI11lPhoneNumber = (_c = userInfoRef.current) === null || _c === void 0 ? void 0 : _c.validateI11lPhoneNumber();
        if (!(applyJobParams === null || applyJobParams === void 0 ? void 0 : applyJobParams.appPhoneNumber) || isNotValidI11lPhoneNumber) {
            error.isPhoneError = true;
            isValid = false;
        }
        setApplyError(error);
        return isValid;
    };
    var getJobUrlParams = function () {
        if (!jobInfo.link)
            return {};
        var urlSearch = jobInfo.link.split('?');
        if (!urlSearch || urlSearch.length < 1)
            return {};
        var searchParams = new URLSearchParams(urlSearch[1]);
        var searchParamsObj = Object.fromEntries(searchParams);
        return searchParamsObj;
    };
    var handleApplyJob = function () { return __awaiter(_this, void 0, void 0, function () {
        var isValid, jobUrlParams, params, reponse, userId, error_3;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    isValid = validate();
                    if (!isValid)
                        return [2 /*return*/];
                    if (!isCheckedPrivacy && privacyPolicy.length > 0) {
                        setShowPrivacyError(true);
                        return [2 /*return*/];
                    }
                    setLoading(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    jobUrlParams = getJobUrlParams();
                    params = __assign(__assign({}, applyJobParams), jobUrlParams);
                    return [4 /*yield*/, applyJobs(params, baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', lang)];
                case 2:
                    reponse = _b.sent();
                    if (((reponse === null || reponse === void 0 ? void 0 : reponse.status) === 'SYSTEM_ERROR' || 'ERROR') && (reponse === null || reponse === void 0 ? void 0 : reponse.message)) {
                        setApplyMessage(reponse === null || reponse === void 0 ? void 0 : reponse.message);
                    }
                    if (reponse === null || reponse === void 0 ? void 0 : reponse.redirectUrl) {
                        userId = (_a = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo) === null || _a === void 0 ? void 0 : _a.userid;
                        setProfileSettingCookie({ chooseCV: applyType === EApplyType.online ? 'profile' : 'attach-cv' }, userId ? String(userId) : '');
                        window.location.href = reponse.redirectUrl;
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_3 = _b.sent();
                    console.error(error_3);
                    return [3 /*break*/, 4];
                case 4:
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderRadioGroup = function () {
        var _a;
        return (_a = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) === null || _a === void 0 ? void 0 : _a.map(function (resume, index) {
            if (!resume || !resume.enabled)
                return;
            return (React__default.createElement(Radio, { t: t, resume: resume, key: "".concat(resume, "_").concat(index), type: resume.type, checked: applyType === (resume === null || resume === void 0 ? void 0 : resume.type), onClick: handleChangeResume, accessToken: decryptToken !== null && decryptToken !== void 0 ? decryptToken : '', langCode: lang !== null && lang !== void 0 ? lang : ELanguage.VI, baseUrl: baseUrl !== null && baseUrl !== void 0 ? baseUrl : '', baseMsUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '', attachmentInfo: resumeSettingInfo === null || resumeSettingInfo === void 0 ? void 0 : resumeSettingInfo.AttachmentInfo, setIsDisable: setIsDisable }));
        });
    };
    var hrefWowCV = function () {
        var queryParams = objToQueryStr(utm !== null && utm !== void 0 ? utm : {});
        var wowCVLink = "wowcv.vietnamworks.com/".concat(lang === ELanguage.EN ? 'en' : '', "?").concat(queryParams);
        var appMode = (baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.includes('staging')) ? 'staging' : (baseUrl === null || baseUrl === void 0 ? void 0 : baseUrl.includes('release')) ? 'release' : '';
        return "https://".concat(!appMode ? wowCVLink : "".concat(appMode, "-").concat(wowCVLink));
    };
    var renderValidateSearchable = function (type) {
        var profileSettingsHref = "".concat(baseUrl, "/").concat(t('quan-ly-nghe-nghiep'), "/").concat(t('thiet-lap-ho-so'));
        if (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.isDisabled) {
            return (React__default.createElement("p", null,
                t('Hiện tại bạn không thể bật chức năng tìm kiếm hồ sơ vì nhập sai thông tin liên hệ. Vui lòng liên hệ với Vietnamworks để xác nhận lại thông tin qua email:'),
                ' ',
                React__default.createElement(Link, { href: 'mailto:contact@vietnamworks.com' }, "contact@vietnamworks.com"),
                "."));
        }
        switch (type) {
            case EApplyType.lastAttachment:
                return (React__default.createElement("p", null,
                    t('Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ đính kèm. Cập nhật thông tin tại'),
                    ' ',
                    React__default.createElement(Link, { href: profileSettingsHref }, t('Thiết lập hồ sơ')),
                    "."));
            case EApplyType.newAttachment:
                return (React__default.createElement("p", null,
                    t('Chưa đủ thông tin để sử dụng chức năng Cho phép Nhà tuyển dụng tìm kiếm hồ sơ vừa tải lên. Cập nhật thông tin tại'),
                    ' ',
                    React__default.createElement(Link, { href: profileSettingsHref }, t('Thiết lập hồ sơ')),
                    "."));
            default:
                return React__default.createElement(React__default.Fragment, null);
        }
    };
    var renderResumeTilte = function () {
        switch (applyType) {
            case EApplyType.online:
                return t('Hồ Sơ VietnamWorks');
            case EApplyType.lastAttachment:
                return t('Hồ Sơ Đính Kèm');
            case EApplyType.newAttachment:
                return t('Hồ Sơ Vừa Tải Lên');
            default:
                return '';
        }
    };
    var getJobLevels = function () { return __awaiter(_this, void 0, void 0, function () {
        var jobLevels_1, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getJobLevelList(lang, baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : '')];
                case 1:
                    jobLevels_1 = _a.sent();
                    if (jobLevels_1 && jobLevels_1.length > 0) {
                        setJobLevels(jobLevels_1);
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_4 = _a.sent();
                    console.error(error_4);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleUserLevelName = function () {
        var level = jobLevels === null || jobLevels === void 0 ? void 0 : jobLevels.find(function (level) { return level.id === (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId); });
        return lang === ELanguage.EN ? level === null || level === void 0 ? void 0 : level.attributes.nameEn : level === null || level === void 0 ? void 0 : level.attributes.nameVi;
    };
    useEffect(function () {
        if (jobLevels && (jobLevels === null || jobLevels === void 0 ? void 0 : jobLevels.length) > 0) {
            return;
        }
        if (isShow) {
            getJobLevels();
        }
    }, [jobLevels, isShow]);
    useEffect(function () {
        var isUserLowLevel = (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId) === INTERN_LEVEL || (userInfo === null || userInfo === void 0 ? void 0 : userInfo.jobLevelId) === FRESHER_LEVEL;
        var isJobHighLevel = (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelId) === MANAGER_LEVEL || (jobInfo === null || jobInfo === void 0 ? void 0 : jobInfo.jobLevelId) === DIRECTOR_LEVEL;
        var isAllowApplyJobs = !(isJobHighLevel && isUserLowLevel);
        if (isAllowApplyJobs && isShow) {
            setIsShowApplyJob(true);
            handleClose();
        }
    }, [isShow, userInfo, jobInfo]);
    useEffect(function () {
        if (!isShow) {
            return;
        }
        (function () { return __awaiter(_this, void 0, void 0, function () {
            var privacyPolicyResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!decryptToken) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getPrivacyPolicy({
                                accessToken: decryptToken,
                                body: {
                                    jobIds: [jobId]
                                },
                                langCode: lang,
                                baseUrl: baseMsUrl !== null && baseMsUrl !== void 0 ? baseMsUrl : ''
                            })];
                    case 1:
                        privacyPolicyResponse = _a.sent();
                        setPrivacyPolicy(privacyPolicyResponse);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [isShow, decryptToken]);
    var onCheckChanged = function () {
        setCheckedPrivacy(!isCheckedPrivacy);
    };
    return (React__default.createElement("div", null,
        isShow && userInfo ? (React__default.createElement(PopupWarning, { isShow: isShow, langCode: lang, onClose: function () {
                handleClose();
                onForceClose && onForceClose();
            }, onAccept: function () {
                setIsShowApplyJob(true);
                handleClose();
            }, title: t('Xác nhận ứng tuyển'), warningTxt: t('Bạn có muốn tiếp tục nộp đơn?') },
            t('Cấp bậc hiện tại của bạn'),
            ": ", (_b = handleUserLevelName()) !== null && _b !== void 0 ? _b : '',
            ' ',
            t('chưa phù hợp với yêu cầu công việc này'),
            ".")) : null,
        React__default.createElement(PopupQuickApplyJob, { className: 'popup__quickApply', isShow: isShowApplyJob, lang: lang, onClose: function () {
                setIsShowApplyJob(false);
                onForceClose && onForceClose();
            }, styleOption: {
                size: 'md'
            }, custom: {
                header: React__default.createElement(React__default.Fragment, null),
                footer: React__default.createElement(React__default.Fragment, null)
            } },
            React__default.createElement(Container, { className: 'popup_container' },
                React__default.createElement(Head, { className: 'popup__head' },
                    React__default.createElement(CompanyInfo, { handleClose: function () {
                            setIsShowApplyJob(false);
                            onForceClose && onForceClose();
                        }, jobInfo: jobInfo })),
                React__default.createElement(Body, { className: 'popup__body' },
                    (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo) ? (React__default.createElement(UserInfo, { ref: userInfoRef, userInfo: applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo, accessToken: decryptToken, lang: lang, baseUrl: baseMsUrl, handleChange: handleChangeInput, t: t, applyError: applyError })) : (React__default.createElement(UserInfoSkeleton, null)),
                    applyJobInfo ? (React__default.createElement(React__default.Fragment, null,
                        (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.preferedLanguage) &&
                            (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.requiredCoverLetter) &&
                            (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.requiredCoverLetter) !== 0 ? (React__default.createElement(CoverLetter, null,
                            React__default.createElement("p", null,
                                t('Thư giới thiệu'),
                                (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.requiredCoverLetter) === 2 ? (React__default.createElement("b", null,
                                    " (",
                                    t('Không bắt buộc'),
                                    ")")) : (''),
                                ":"),
                            React__default.createElement(Textarea, { placeholder: t('Nhập thư giới thiệu'), maxLength: 5000, onChange: onTextAreaChange }),
                            applyError.isCoverLetterError ? (React__default.createElement(ErrorMsg, null, t('Vui lòng nhập thông tin.'))) : null,
                            React__default.createElement(AlignRight, null,
                                React__default.createElement(Link, { href: 'https://www.vietnamworks.com/hrinsider/ho-so-ung-tuyen.html', target: '_blank' }, t('Xem mẫu thư giới thiệu'))))) : null,
                        React__default.createElement(ApplyCV, { className: 'body__applyCV' },
                            React__default.createElement(ApplyCVTitle, null,
                                React__default.createElement(ApplyCVTitle, null,
                                    (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) && applyJobInfo.resumes.length > 0 ? (React__default.createElement(React__default.Fragment, null,
                                        t('Chọn hồ sơ ứng tuyển'),
                                        ": ")) : null,
                                    (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.preferedLanguage) &&
                                        ((_c = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.preferedLanguage) === null || _c === void 0 ? void 0 : _c.selectedid) !== '3' ? (React__default.createElement("span", null,
                                        t('Nhà tuyển dụng ưu tiên hồ sơ ứng tuyển viết bằng'),
                                        ' ',
                                        React__default.createElement("b", null, (_e = (_d = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.preferedLanguage) === null || _d === void 0 ? void 0 : _d.selectedname) !== null && _e !== void 0 ? _e : ''))) : (''))),
                            renderRadioGroup(),
                            ((applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) && ((_f = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) === null || _f === void 0 ? void 0 : _f.length) < 1) ||
                                (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.isSearchable) ? null : (React__default.createElement(Searchable, { isDisabled: isDisable || (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.isDisabled) },
                                React__default.createElement("div", null,
                                    React__default.createElement("input", { type: 'checkbox', disabled: isDisable || (applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.isDisabled), onChange: onClickMakeSearchable, checked: isSearchable }),
                                    React__default.createElement("span", null,
                                        t('Cho phép Nhà tuyển dụng tìm kiếm'),
                                        " ",
                                        React__default.createElement("b", null, renderResumeTilte()))),
                                applyJobInfo && (isDisable || applyJobInfo.isDisabled)
                                    ? renderValidateSearchable(applyType)
                                    : null)),
                            React__default.createElement(AlignRight, null,
                                React__default.createElement(Link, { href: hrefWowCV(), target: '_blank' }, t('Tạo hồ sơ ấn tượng với WowCV')))))) : (React__default.createElement(JobInfoSkeletion, null)),
                    React__default.createElement(UploadFile, { ref: uploadFileRef, t: t, accessToken: decryptToken, userId: (_h = Number((_g = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.userInfo) === null || _g === void 0 ? void 0 : _g.userid)) !== null && _h !== void 0 ? _h : 0, jobId: jobId !== null && jobId !== void 0 ? jobId : 0, lang: lang, baseUrl: baseMsUrl, applyJobInfo: applyJobInfo, setApplyJobInfo: setApplyJobInfo }),
                    (privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.length) > 0 && (React__default.createElement(PrivacyPolicyContainer, null,
                        React__default.createElement(CheckBoxGroup, null,
                            React__default.createElement(CheckBox, { label: '', state: isCheckedPrivacy ? 'checked' : 'none', onCheckChange: function (value) { return setCheckedPrivacy(value === 'checked'); } }),
                            React__default.createElement(CheckboxLabel, null,
                                React__default.createElement("span", { onClick: onCheckChanged }, t('Tôi đồng ý với')),
                                ' ',
                                React__default.createElement(CheckboxLink, { href: privacyPolicy && (privacyPolicy === null || privacyPolicy === void 0 ? void 0 : privacyPolicy.length) > 0 ? (_j = privacyPolicy[0]) === null || _j === void 0 ? void 0 : _j.fileUrl : '#', target: '_blank' }, t('Quy định bảo mật')),
                                ' ',
                                React__default.createElement("span", { onClick: onCheckChanged }, t('của nhà tuyển dụng này.')),
                                React__default.createElement("span", { className: 'required' }, "(*)"))),
                        isPrivacyError && (React__default.createElement(ErrorMessage, null, t('Vui lòng đánh dấu vào hộp chọn để tiếp tục nộp đơn.')))))),
                applyMessage ? React__default.createElement(SystemError, { message: applyMessage, onClose: function () { return setApplyMessage(''); } }) : null),
            React__default.createElement(ButtonWrap, null,
                React__default.createElement(Button, { type: 'primary', className: 'custom-btn', onClick: handleApplyJob, disabled: !applyJobInfo || ((applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) && ((_k = applyJobInfo === null || applyJobInfo === void 0 ? void 0 : applyJobInfo.resumes) === null || _k === void 0 ? void 0 : _k.length) < 1) || isLoading },
                    isLoading && React__default.createElement(LoadingIcon, { bgColor: colors.bgNormal }),
                    t('Nộp Đơn'))))));
}

export { QuickApplyJobModal as default };
//# sourceMappingURL=index.js.map
